// extracted by mini-css-extract-plugin
export default {"container":"CityInfoTab_container__+MbWx"};